<vpfa-mobile-page-title [title]="'confirmAdvertisedImagesModal.title' | translate"> </vpfa-mobile-page-title>
<vpfa-common-confirm-advertised-images-modal (cancel)="cancelUpload()"></vpfa-common-confirm-advertised-images-modal>
